import './App.css';
import AuthProvider from './providers/AuthProvider';
import AppRouter from './routes/AppRouter';
import ThemeProvider from './providers/ThemeProvider';

function App() {
    return (
        <ThemeProvider>
            <AuthProvider>
                <AppRouter />
            </AuthProvider>
        </ThemeProvider>
    );
}

export default App;
